import React from "react";
import PageHeader from "../PageHeader"; // Import the component
import OurWorkSection from "../OurWork"; // Your existing About Section
import heroBackImage from "../images/hero/hero.webp"; // Import the background image you want

const AboutPage = () => {
  
  // 1. Define the breadcrumb path
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "أعمالنا", path: "/our-work" } // The last one is the active page
  ];

  return (
    <>
      {/* 2. Use the Component */}
      <PageHeader 
        title="أعمالنا" 
        bgImage={heroBackImage} 
        breadcrumbs={breadcrumbLinks} 
      />

      {/* The rest of your page content */}
      <OurWorkSection />
    </>
  );
};

export default AboutPage;